import { BufferImageSource, Texture } from "pixi.js";

export function shieldTexture(kind: "shell" | "impact" | "ripple"): Texture {
  const size = 128;
  const pixels = new Uint8Array(size * size * 4);
  for (let y = 0; y < size; y++)
    for (let x = 0; x < size; x++) {
      const nx = (x - 63.5) / 63.5;
      const ny = (y - 63.5) / 63.5;
      const radius = Math.hypot(nx, ny);
      const edge = Math.max(0, Math.min(1, (1 - radius) * 24));
      const rim = Math.exp(-Math.pow((radius - 0.94) / 0.032, 2));
      const light = Math.max(0, (-nx - ny) * 0.7);
      let alpha: number;
      if (kind === "shell")
        alpha =
          edge * (0.035 + radius ** 4 * 0.12 + rim * (0.4 + light * 0.35));
      else if (kind === "impact")
        alpha =
          edge *
          Math.exp(-Math.pow((radius - 0.91) / 0.085, 2)) *
          Math.exp(-Math.pow(Math.atan2(ny, nx) / 0.32, 2));
      else alpha = Math.exp(-Math.pow((radius - 0.88) / 0.028, 2)) * edge;
      const index = (y * size + x) * 4;
      pixels[index] = kind === "impact" ? 190 : 70 + Math.round(light * 50);
      pixels[index + 1] =
        kind === "impact" ? 240 : 185 + Math.round(light * 35);
      pixels[index + 2] = 255;
      pixels[index + 3] = Math.round(Math.min(1, alpha) * 255);
    }
  return new Texture({
    source: new BufferImageSource({
      resource: pixels,
      width: size,
      height: size,
      format: "rgba8unorm",
      alphaMode: "no-premultiply-alpha",
      scaleMode: "linear",
    }),
  });
}
